var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-section" },
    [
      _c("div", { staticClass: "section-title" }, [_vm._v("客户信息")]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-form-item", { attrs: { label: "客户姓名" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.customerInfo.contactPerson || "-")),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-form-item", { attrs: { label: "客户电话" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.customerInfo.contactNumber || "-")),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-form-item", { attrs: { label: "客户地址" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.customerInfo.contactAddress || "-")),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-form-item", { attrs: { label: "坐标" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.customerInfo.coordinate || "-")),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }